module.exports = __webpack_public_path__ + "mainassets/img/navbar-vector2.76660370.svg";